<template>
    <tr class="timing-hall-base-table__row timing-hall-base-table__row_head">
        <th class="timing-hall-base-table__cell timing-hall-base-table__cell_head timing-hall-base-table__cell_sortable" scope="col"
            v-for="column in columns"
            :key="column.id"
            @click="setTimingHallSorting(column.id)"
        >
            <div class="timing-hall-base-table__cell-content timing-hall-base-table__cell-content_columns"
                :class="`timing-hall-base-table__cell-content_${column.alignment}`"
            >
                <span class="timing-hall-base-table__value">{{column.title}}</span>
                <svg-icon v-if="field === column.id" class="timing-hall-base-table__value timing-hall-base-table__value_icon"
                    :icon="direction === 'ASC' ? 'chevron-up' : 'chevron-down'"
                />
            </div>
        </th>
    </tr>
</template>

<script>
    import { mapMutations, mapState } from "vuex";

    export default {
        name: "TimingHallBaseTableHeadRow",
        components: {
        },
        props: {
            columns: {
                type: Array,
                required: true
            }
        },
        computed: {
            ...mapState({
                field: state => state.timingHall.sorting.field,
                direction: state => state.timingHall.sorting.direction,
            }),
        },
        methods: {
            ...mapMutations([
                "setTimingHallSorting",
            ]),
        }
    };
</script>
